export default "__VITE_ASSET__BQKb3dbs__"